import { render, staticRenderFns } from "./StrapiQuestionComponent.vue?vue&type=template&id=67606f48"
import script from "./StrapiQuestionComponent.vue?vue&type=script&lang=js"
export * from "./StrapiQuestionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports